<template>
  <figure 
    :class="{ 'landing' : isLanding }">
    
    <svg viewBox="0 0 596 152"
      class="main-logo"
      :class="[isDark ? 'is-dark' : '', isBlack ? 'is-black' : '']">
      <g id="logo_1_">
	<g>
		<g>
			<g>
				<path class="st0" d="M73.7,2.2c96.6,1.6,96.5,145.3,0,146.9C-22.9,147.5-22.9,3.8,73.7,2.2z"/>
			</g>
			<g>
				<g>
					<path class="st1" d="M73.7,37.1c-20,0-20.8,26.1-20.8,38.5c-0.6,10.1,1,39.5,20.8,38.6c19.6,0.9,21.4-28.8,20.8-38.6
						C94.5,65.7,94.8,37.1,73.7,37.1z M73.7,107.1c-10.6,0-13-11.3-13-31.5c0-11-0.3-31.4,13-31.4c13.3,0,13,17.2,13,31.4
						C86.6,88.7,86.8,107.1,73.7,107.1z"/>
				</g>
				<g>
					<path class="st1" d="M112.2,75.7c0-20-26.1-20.8-38.5-20.8c-10.1-0.6-39.5,1-38.6,20.8c-0.9,19.6,28.8,21.4,38.6,20.8
						C83.6,96.5,112.2,96.8,112.2,75.7z M42.2,75.7c0-10.6,11.3-13,31.5-13c11,0,31.4-0.3,31.4,13c0,13.3-17.2,13-31.4,13
						C60.7,88.6,42.2,88.7,42.2,75.7z"/>
				</g>
			</g>
		</g>
		<g class="st0">
			<path d="M229.2,26.7c13.1,0,23.2,2.3,30.1,7c15.9,10.2,13.6,39.9-5.9,45.7c8.4,10.6,15.9,23.4,21.7,35.7h-22
				c-6.1-10.8-12.3-22.4-20.1-31.9h-9.7v31.9h-19.7V29C211.4,27.4,221.5,26.7,229.2,26.7z M230.3,43.5c-2.6,0-4.7,0.2-7.1,0.4v23.7
				c6.9,0.2,18-0.2,21.4-2.8c6.3-3.1,6.5-15.5-0.1-18.6C241.4,44.4,236.6,43.5,230.3,43.5z"/>
			<path class="st0" d="M345.4,48.8c-7.3,24.4-15,46.2-25.4,68.5c-6.7,18.7-23.8,25.9-41.8,18.5l3.3-15c9.3,3.7,19.3,2.1,22.3-8.4
				c-10-19.7-18.3-40.4-25-63.6h19.9c3.8,14.2,8.9,30,14.2,43.8c4.9-13.8,9.3-29.6,13-43.8H345.4z"/>
			<path class="st0" d="M415.7,81.8c1.3,46.8-66.2,46.5-65.2,0C349.8,35.7,416.5,35.5,415.7,81.8z M396.5,81.8
				c1.5-24.8-28.3-24.7-26.9,0C368.3,106.8,397.9,106.9,396.5,81.8z"/>
			<path class="st0" d="M466.6,79.9c0.7-14-5.2-18.8-17.7-16v51.2h-18.8V51c14.3-3.2,34.2-7.9,46.3,2.4c8.5-6.4,22.9-7.9,32-4
				c21.3,9,11.2,47.7,13.4,65.6h-18.8V79.9c1.1-14.3-7.2-20.8-19-14c2.7,8.7,0.9,39.8,1.4,49.2h-18.8V79.9z"/>
			<path class="st0" d="M562.7,47c40.2-1.8,26.6,41,28.9,66.2c-13.9,2.7-35.6,6.9-49.3-1.6c-8.2-5.2-9.9-18.6-5.5-26.8
				C544,73,561.5,72.6,573.6,75c1.9-16.5-20.4-13-30.5-9.7l-2.4-15.1C547.5,48.2,555.4,47.1,562.7,47z M564.2,102
				c3,0,6.7-0.1,9.3-0.5V87.2C550.7,81.4,545.5,101.8,564.2,102z"/>
		</g>
	</g>
</g>

    </svg>

  </figure>
</template>

<script>
  export default {
    name: 'main-logo',
    props: ['isDark', 'isLanding', 'isBlack']
  }
</script>

<style lang="scss" scoped>
  @import '../styles/_mixins.scss';

  figure {
    margin: 0 auto;
    padding: $large_vmin 0;
    max-width: 35vmin;

    @include respond-to(tablet) {
      padding: $default_vmin 0;
      max-width: 20vmin;
    }

    @include respond-to(desktop) {
      margin: 0;
      max-width: 15vmin;
    }

    svg {
      .st0{fill:#D5471C;}   
      .st1{fill:#FFFFFF;}

      &.is-dark{
        .st0{fill:#fff;}   
        .st1{fill: map-get($colors--accents, 'fourth');}
      }
      &.is-black{
        .st0{fill:#fff;}   
        .st1{fill: black;}
      }
    }
  }
</style>
